import React, { useState } from 'react';
import { withStyles } from '@material-ui/core';
import { styles } from "./style";
import Popover from '@material-ui/core/Popover';
import Icon from "storybookComponents/Icon"
import "./style.css"
import Tooltip from "storybookComponents/Tooltip"
import ModalWithTabs from "../ModalWithTab";
import { PreviewUrl, EmbedUrl, TickIcon } from "icons"
import IconComponent from "components/IconComponent";

const DropDown = ({ classes, placeHolder, data }) => {
  const [eventModalOpen, setEventModalOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [copied, setCopy] = React.useState();
  const [view, setView] = React.useState(1);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;


  const handleClickOpen = (index) => {
    if (index === 0) {
      return window.open(data[index].url);
    }
    setEventModalOpen(true);
    setView(index)
  };
  const handleCloseEventModal = () => {
    setEventModalOpen(false);
  };

  const copyTextToClipboard = (text, index) => {
    navigator.clipboard.writeText(text).then(function () {
      setCopy(index);
      setTimeout(() => {
        setCopy(null);
      }, 2000)
    }, function (err) {
      console.error('Async: Could not copy text: ', err);
    });
  }

  const renderList = (listItem, index) => {
    let iconType = copied === index ? TickIcon : listItem.title === "Preview" ? PreviewUrl : EmbedUrl;
    let tooltip_text;


    const clickText = () => {
      handleClickOpen(index)
    }

    const clickIcon = () => {
      if (index === 0) {
        handleClickOpen(index)
      } else {
        copyTextToClipboard(listItem.url, index)
      }
    }

    if (index === 0) {
      tooltip_text = "Open preview in new tab";
    } else if (index === 1) {
      tooltip_text = copied === index ? "URL copied" : "Click to copy";
    } else {
      tooltip_text = copied === index ? "Code copied" : "Click to copy";
    }
    return (
      <div key={index} className={classes.list}>
        <div className={classes.hover} onClick={clickText}>{listItem.title}</div>
        <div className={classes.hover} >
          <Tooltip placement="bottom" tooltip_text={tooltip_text}>
            <IconComponent onHoverColor="#26bbed" onClick={clickIcon} Component={iconType} />
            {/* <div className={`${copied === index && classes.checkIconStyle}`}>
              <Icon type={iconType} size="sm" onClick={clickIcon} />
            </div> */}
          </Tooltip>
        </div>
      </div>)
  }

  return (
    <div>
      <div id="Upcoming-dropdown">
        <div className={classes.buttonClass} onClick={handleClick}>
          <div className={classes.buttonContent}>
            {placeHolder}
            <Icon className={`${classes.iconClass}`} type={open ? "icon-triangle-up" : "icon-triangle-down"} size="xs" />
          </div>
        </div>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          classes={{
            paper: classes.paper,
          }}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <div>
            {data.map(renderList)}
          </div>
        </Popover>
      </div>
      < ModalWithTabs view={view} setView={setView} copyTextToClipboard={copyTextToClipboard} data={data} open={eventModalOpen} handleCloseEventModal={handleCloseEventModal} />
    </div>

  );
}

export default (withStyles(styles)(DropDown))